<template>
	<v-dialog
	v-model="dialog"
	width="500"
	>
	<template v-slot:activator="{ on }">
	<v-btn color="red" dark small v-on="on" class="float-right ml-4">
		Delete
	</v-btn>
	</template>
	<v-card>
		<v-card-title>Confirm Deletion</v-card-title>
		<v-card-text>
		Are you sure you want to delete this item? Deleted items can only be retrieved with difficulty. 
		</v-card-text>

	<v-divider></v-divider>

	<v-card-actions>
	<v-spacer></v-spacer>
		<v-btn
		color="red"
		text
		@click="deleteItem"
		>
			Delete	
		</v-btn>
	</v-card-actions>
	</v-card>
	</v-dialog>

</template>

<script type="text/javascript">
	export default{
		name: "Delete", 
		props: ["item", "collection"], 
		data: () => ({
			dialog: false,
		}),
		methods: {
			deleteItem(){
				const self = this;
				var doc = self.collection + "/" + self.item.id;
				self.item.collection = self.collection;

				if( ['participants', 'admins', 'clients'].indexOf( self.collection ) > -1 ){
					self.item.collection = "users";
					doc = "users/" + self.item.id
				}
				self.$store.dispatch("addDoc", {
					data: self.item, 
					collection: "deletedItems"
				}).then( () => {
					self.$store.dispatch("updateDoc", {
						doc: doc,
						action: "delete"
					}).then( () =>{
						self.dialog = false
						self.$store.dispatch( "delete", {id: self.item.id, collection: self.collection} )
					})
				})
			}
		}
	}
</script>